import { useState, useCallback } from 'react';
import { companyInfo } from '../data/mockData';

const buildWhatsAppText = ({ name, email, phone, message }) =>
  encodeURIComponent(
    `Hi SS Consultancy,\n\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\n\n${message}`
  );

const EMPTY = { name: '', email: '', phone: '', message: '' };

export const useContactForm = () => {
  const [form, setForm] = useState(EMPTY);
  const [submitted, setSubmitted] = useState(false);

  const onChange = useCallback((e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }, []);

  const onSubmit = useCallback((e) => {
    e.preventDefault();
    const url = `https://wa.me/${companyInfo.whatsappRaw}?text=${buildWhatsAppText(form)}`;
    window.open(url, '_blank');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setForm(EMPTY);
  }, [form]);

  return { form, submitted, onChange, onSubmit };
};
